import GrayCard from "components/gray-card";
import Radio from "components/radio";
import Typography from "components/typography";
import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  lyricType: string;
  setLyricType: (value: string) => void;
}
const Lyrics = ({ lyricType, setLyricType }: IProps) => {
  return (
    <GrayCard title="Lyrics">
      {" "}
      <Typography color={Colors.grey400} weight="medium">
        Do these lyrics contain explicit content?
      </Typography>
      <LyricRadio>
        <Radio
          value={lyricType === "explicit"}
          onClick={() => setLyricType("explicit")}
        />
        <Typography color={Colors.white200} ml="0.4" size="s">
          Explicit Content (This track includes profanity or offensive language)
        </Typography>
      </LyricRadio>
      <LyricRadio>
        <Radio
          value={lyricType === "clean"}
          onClick={() => setLyricType("clean")}
        />
        <Typography color={Colors.white200} ml="0.4" size="s">
          Clean (There is another version, that contains profanity or offensive
          language and this is the clean version)
        </Typography>
      </LyricRadio>
      <LyricRadio>
        <Radio
          value={lyricType === "not-explicit"}
          onClick={() => setLyricType("not-explicit")}
        />
        <Typography color={Colors.white200} ml="0.4" size="s">
          Not Explicit (This track does NOT include profanity or offensive
          language)
        </Typography>
      </LyricRadio>
    </GrayCard>
  );
};

export default Lyrics;

const LyricRadio = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1.6rem;
  @media only screen and (max-width: 769px) {
    display: grid;
    grid-template-columns: 5% 95%;
  }
`;
